// -------- ROUTES FOR AUTHENTICATION -------
export const verifyCode = "/register/verify";
export const sendVerification = (phone) => `/register/otp?phone=${phone}`;
export const register = "/register";
export const login = "/login";
export const forgotPassword = (email) => `/forgot/password?email=${email}`;

// -------- ROUTES FOR WALLET ---------------
export const wallet = "/wallet"; // GET
export const walletDeposit = (currency, amount) =>
  `/wallet/deposit?currency=${currency}&amount=${amount}`; // GET
export const walletWithdraw = (currency, amount, accountId) =>
  `/wallet/withdraw?currency=${currency}&amount=${amount}&accountId=${accountId}`; // GET
export const walletQuote = (fromcurrency, fromamount, tocurrency, toamount) =>
  `/wallet/quote?fromcurrency=${fromcurrency}&fromamount=${fromamount}&tocurrency=${tocurrency}&toamount=${toamount}`; // GET
export const walletSwap = (fromcurrency, fromamount, tocurrency, toamount) =>
  `/wallet/swap?fromcurrency=${fromcurrency}&fromamount=${fromamount}&tocurrency=${tocurrency}&toamount=${toamount}`; // GET

// --------- ROUTES FOR TRANSFER ------------
export const beneficiary = "/transfer/beneficiary"; // POST && GET  // ADD to Beneficiary ( POST ) and GET Beneficiaries ( GET )
export const updateBeneficiary= (beneficiaryId) => `/transfer/beneficiary/${beneficiaryId}`
export const sendToBeneficiary = (beneficiaryId, amount) =>
  `/transfer/send?beneficiaryId=${beneficiaryId}&amount=${amount}`; // GET

// ---------- ROUTES FOR ACCOUNTS -----------
export const accountProfile = "/account/profile"; // GET
export const accountPin = "/account/pin"; // POST
export const accountPassword = "/account/password"; // POST
export const accountBanks = "/account/banks/list"; // GET
export const accountKYC = "/account/kyc"; // POST & GET
export const accountBVN = "/account/bvn"; // POST & GET
export const bankAccount = "/account/banks"; // POST & GET
export const deleteCard = (bankId) => `/account/banks?bankId=${bankId}`; // DELETE

// ---------- ROUTES FOR DEBIT CARD ----------
export const debitCard = "/card"; // GET
export const newCard = (currency) => `/card/new?currency=${currency}`; // GET
export const blockCard = (cardId) => `/card/block?cardId=${cardId}`; // GET
export const fundAccount = (cardId, amount) =>
  `/card/fund?cardId=${cardId}&amount=${amount}`; // GET

// ---------- ROUTES FOR TRANSACTION --------

export const transactions = (type) => `/transactions/${type}`;

export const withdrawTransactions = "/transactions/withdraw";
export const depositTransactions = "/transactions/deposit";
export const transferTransactions = "/transactions/transfer";
export const swapTransactions = "/transactions/swap";
export const cardTransactions = "/transactions/card";

